module.exports = __webpack_public_path__ + "assets/img/nested.c948fb38.svg";